import { Link, NavLink, useNavigate } from "react-router-dom";
import { Gift, Menu, X } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/Auth";

const navCls = ({ isActive }) =>
  `text-sm font-medium transition-colors hover:text-[#7E5BAF] ${isActive ? "text-[#7E5BAF]" : "text-[#261E1B]"}`;

export const Header = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const area = user && { admin: ["/admin", "Amministrazione"], acquirente: ["/account", "Le mie gift card"] }[user.ruolo];
  const links = (
    <>
      <NavLink to="/" end className={navCls} data-testid="nav-catalogo" onClick={() => setOpen(false)}>Catalogo</NavLink>
      <NavLink to="/verifica-saldo" className={navCls} data-testid="nav-verifica-saldo" onClick={() => setOpen(false)}>Verifica saldo</NavLink>
      {area && <NavLink to={area[0]} className={navCls} data-testid="nav-area" onClick={() => setOpen(false)}>{area[1]}</NavLink>}
      {user ? (
        <button className="btn-secondary btn-sm" data-testid="logout-btn" onClick={async () => { await logout(); nav("/"); }}>Esci</button>
      ) : (
        <Link to="/accedi" className="btn-primary btn-sm" data-testid="nav-accedi" onClick={() => setOpen(false)}>Accedi</Link>
      )}
    </>
  );
  return (
    <header className="backdrop-blur-md bg-[#FAF7FD]/85 border-b border-[#E3D9F0] sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <span className="w-9 h-9 rounded-full bg-[#7E5BAF] text-[#FFFEFF] grid place-items-center"><Gift size={18} /></span>
          <span className="font-display text-2xl font-semibold tracking-tight">Regalami</span>
        </Link>
        <nav className="hidden md:flex items-center gap-7">{links}</nav>
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn" aria-label="Menu">{open ? <X /> : <Menu />}</button>
      </div>
      {open && <nav className="md:hidden flex flex-col gap-4 px-6 pb-5 items-start">{links}</nav>}
    </header>
  );
};

export const Footer = () => (
  <footer className="border-t border-[#E3D9F0] mt-24 bg-[#F1EAF8]">
    <div className="max-w-7xl mx-auto px-6 py-12 grid gap-8 md:grid-cols-3 text-sm text-[#786E65]">
      <div>
        <p className="font-display text-2xl text-[#261E1B]">Regalami</p>
        <p className="mt-2 max-w-xs">Gift card delle attività locali italiane, da regalare in un attimo.</p>
      </div>
      <div className="flex flex-col gap-2">
        <Link to="/verifica-saldo" className="hover:text-[#7E5BAF]">Verifica saldo</Link>
      </div>
      <p>Pagamenti sicuri gestiti da Stripe. Nessun dato della carta transita sui nostri server.</p>
    </div>
  </footer>
);

export const Page = ({ children, className = "" }) => (
  <main className={`max-w-7xl mx-auto px-4 sm:px-6 py-10 fade-up ${className}`}>{children}</main>
);

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="label">{label}</span>
    {children}
    {hint && <span className="text-xs text-[#786E65] mt-1 block">{hint}</span>}
  </label>
);

export const Spinner = () => (
  <div className="py-24 grid place-items-center" data-testid="loading">
    <div className="w-8 h-8 border-2 border-[#7E5BAF] border-t-transparent rounded-full animate-spin" />
  </div>
);
